import React from 'react';
 
const Footer = () => (
    <div className='center t-small t-light pt-45 pb-55'>
        <p>© 2012 - { new Date().getFullYear() } Christopher Bell @ christopherleebell.com - All rights reserved</p>
    </div>
)

export default Footer;